module.exports = __webpack_public_path__ + "static/media/Checkpoint-Kids-Logo-600px.50f9da89.png";